import { Link } from "react-router-dom";
import Seo from "@/components/store/Seo";

export default function NotFound() {
  return (
    <div className="tq-container py-24 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found" noindex />
      <p className="font-serif text-[7rem] leading-none text-[#C59B27]">404</p>
      <h1 className="font-serif text-3xl mt-2 mb-3">This page walked away</h1>
      <p className="text-sm text-[#666666] mb-8 max-w-sm mx-auto">The page you're looking for doesn't exist or has moved. Let's get you back to beautiful footwear.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" className="tq-btn-dark" data-testid="notfound-home-btn">Back to Home</Link>
        <Link to="/collections/new-arrivals" className="tq-btn-outline">Shop New Arrivals</Link>
      </div>
    </div>
  );
}
